<template>
  <div class="cashier-entry">
    <div class="entry-card">
      <div class="entry-kicker">温岭 EATing · 收银台</div>
      <h1 class="entry-title">进入收银台</h1>
      <p class="entry-desc">
        为保障收银安全，请再次输入当前账号登录密码。验证通过后将在新窗口打开收银台，会话 24 小时后自动退出。
      </p>

      <el-form class="entry-form" @submit.native.prevent="submitEnter">
        <div class="entry-account">
          <span class="entry-label">当前账号</span>
          <strong>{{ displayName }}</strong>
        </div>
        <el-form-item label="登录密码">
          <el-input
            v-model="password"
            type="password"
            show-password
            placeholder="请输入登录密码"
            autocomplete="current-password"
            @keyup.enter.native="submitEnter"
          />
        </el-form-item>
        <el-button
          type="primary"
          class="btn-primary entry-btn"
          :loading="submitting"
          @click="submitEnter"
        >
          进入收银台
        </el-button>
      </el-form>

      <p v-if="errorText" class="entry-error">{{ errorText }}</p>
      <p class="entry-hint">若浏览器拦截弹窗，请允许本站打开新窗口后重试。</p>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '../utils/auth'
import { openCashierDeskSession } from '../utils/cashierSession'

export default {
  name: 'CashierEntry',
  data() {
    return {
      password: '',
      submitting: false,
      errorText: ''
    }
  },
  computed: {
    displayName() {
      const u = getUserInfo() || {}
      return u.displayName || u.username || u.name || '管理员'
    },
    username() {
      const u = getUserInfo() || {}
      return String(u.username || '').trim()
    }
  },
  methods: {
    async submitEnter() {
      this.errorText = ''
      if (!this.username) {
        this.errorText = '未获取到登录账号，请重新登录后台'
        return
      }
      if (!String(this.password || '').trim()) {
        this.errorText = '请输入登录密码'
        return
      }
      this.submitting = true
      try {
        const resp = await this.$api.post('/admin/login', {
          username: this.username,
          password: this.password
        })
        if (!(resp && (resp.code === 200 || resp.token || (resp.data && resp.data.token)))) {
          this.errorText = (resp && resp.message) || '密码错误'
          return
        }
        openCashierDeskSession()
        this.password = ''
        const url = `${window.location.origin}${window.location.pathname}#/cashier-desk`
        const win = window.open(url, '_blank')
        if (!win) {
          this.$message.warning('浏览器拦截了新窗口，请允许弹窗后重试，或手动打开收银台窗口')
          this.$router.push('/cashier-desk')
          return
        }
        this.$message.success('已打开收银台新窗口')
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '验证失败'
        this.errorText = String(msg)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.cashier-entry {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background: #f5f5f5;
}

.entry-card {
  width: 100%;
  max-width: 440px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 28px 28px 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.entry-kicker {
  font-size: 13px;
  color: #888;
  margin-bottom: 8px;
}

.entry-title {
  margin: 0 0 10px;
  font-size: 22px;
  font-weight: 700;
  color: #111;
}

.entry-desc {
  margin: 0 0 22px;
  font-size: 14px;
  line-height: 1.65;
  color: #555;
}

.entry-account {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  font-size: 14px;
  color: #333;
}

.entry-label {
  color: #888;
}

.entry-form >>> .el-form-item__label {
  color: #555;
}

.entry-btn {
  width: 100%;
  margin-top: 8px;
  height: 40px;
}

.entry-error {
  margin: 14px 0 0;
  color: #c0392b;
  font-size: 13px;
}

.entry-hint {
  margin: 16px 0 0;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}
</style>
